<template>
  <Layout>
    <div class="is-flex">
      <Card class="w-full">
        <template slot="header">
          <div class>
            <h3 class="is-size-4 has-text-weight-bold">Actualizar Producto</h3>
          </div>
        </template>
        <template slot="content">
          <section>
            <b-tabs v-model="activeTab" :animated="false">
              <b-tab-item>
                <template #header>
                  <span>Información</span>
                </template>
                <div>
                  <h2 class="my-3">Categorías</h2>
                  <div class="scroll-container">
                    <template v-if="categories.length > 0">
                      <div
                        class="field"
                        v-for="c in categories"
                        :key="c.name + c.id"
                      >
                        <b-checkbox
                          :id="'c_' + c.id"
                          :native-value="c.id"
                          v-model="data.category"
                          >{{ c.name }}</b-checkbox
                        >
                      </div>
                    </template>
                    <template v-else>
                      <p>No hay categorías</p>
                    </template>
                  </div>
                  <hr />
                  <h2 class="my-3">Local</h2>
                  <div class="scroll-container">
                    <template v-if="locals.length > 0">
                      <div
                        class="field"
                        v-for="l in locals"
                        :key="l.name + l.id"
                      >
                        <b-checkbox
                          :id="'l_' + l.id"
                          :native-value="l.id"
                          v-model="data.local"
                          >{{ l.name }}</b-checkbox
                        >
                      </div>
                    </template>
                    <template v-else>
                      <p>No hay locales</p>
                    </template>
                  </div>
                  <hr />
                  <b-field label="Activo">
                    <b-switch
                      v-model="data.is_active"
                      type="is-success"
                    ></b-switch>
                  </b-field>
                  <b-field label="Es Oculto">
                    <b-switch
                      v-model="data.is_hidden"
                      type="is-success"
                    ></b-switch>
                  </b-field>
                  <b-field
                    label="Tipo de producto"
                    :custom-class="
                      $v.data.type_product.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.type_product.$error }"
                  >
                    <b-select
                      placeholder="Seleccione"
                      expanded
                      v-model="data.type_product"
                    >
                      <option
                        v-for="type_product in type_products"
                        :value="type_product.value"
                        :key="type_product.value"
                      >
                        {{ type_product.name }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field
                    label="Nombre"
                    :custom-class="$v.data.name.$error ? 'has-text-danger' : ''"
                    :type="{ 'is-danger': $v.data.name.$error }"
                    :message="[{ 'Campo requerido': !$v.data.name.required }]"
                  >
                    <b-input v-model="data.name"></b-input>
                  </b-field>
                  <b-field
                    label="Descripción"
                    :custom-class="
                      $v.data.description.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.description.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.description.required &&
                          $v.data.description.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.description"></b-input>
                  </b-field>
                  <b-field
                    label="Precio"
                    :custom-class="
                      $v.data.price.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.price.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.price.required && $v.data.price.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.price"></b-input>
                  </b-field>
                  <b-field label="Precio Representativo">
                    <b-input v-model="data.price_representative"></b-input>
                  </b-field>
                  <b-field label="Tiene Stock">
                    <b-switch
                      v-model="data.has_stock"
                      type="is-success"
                    ></b-switch>
                  </b-field>
                  <b-field
                    label="Stock"
                    v-if="data.has_stock"
                    :custom-class="
                      $v.data.stock.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.stock.$error }"
                    :message="[{ 'Campo requerido': !$v.data.stock.required }]"
                  >
                    <b-input
                      v-model="data.stock"
                      type="number"
                      min="0"
                    ></b-input>
                  </b-field>
                  <hr />
                  <b-field label="Imagen">
                    <upload
                      :image="data.image"
                      @change="uploadFileImage"
                    ></upload>
                  </b-field>
                  <b-field label="PDF">
                    <b-field class="file is-primary">
                      <b-upload
                        @input="uploadFilePdf"
                        class="file-label"
                        rounded
                      >
                        <span class="file-cta">
                          <b-icon class="file-icon" icon="upload"></b-icon>
                          <span class="file-label">Subir</span>
                        </span>
                      </b-upload>
                    </b-field>
                    <a v-if="data.pdf" :href="data.pdf" target="_blank"
                      >Ver Archivo</a
                    >
                  </b-field>
                </div>
              </b-tab-item>
              <b-tab-item>
                <template #header>
                  <span>Grupo de opciones</span>
                </template>
                <ProductFormCreate></ProductFormCreate>
              </b-tab-item>
              <b-tab-item>
                <template #header>
                  <span>Caracterísitcas</span>
                </template>
                <div>
                  <b-field label="Tamaño">
                    <b-select
                      placeholder="Seleccione una opción"
                      v-model="data.size"
                      expanded
                      class="selectForm"
                    >
                      <option value="XS">Muy pequeño (XS)</option>
                      <option value="S">Pequeño (S)</option>
                      <option value="M">Mediano (M)</option>
                      <option value="L">Grande (L)</option>
                    </b-select>
                    <!--  -->
                  </b-field>
                  <b-field label="Unidad" class="unity">
                    <small>Paquete, Bolsa, etc. </small>
                    <b-input v-model="data.unity"></b-input>
                  </b-field>
                  <b-field
                    label="Peso"
                    :custom-class="
                      $v.data.volumen.$error ? 'has-text-danger' : ''
                    "
                    :type="{ 'is-danger': $v.data.volumen.$error }"
                    :message="[
                      {
                        'Formato incorrecto':
                          !$v.data.volumen.decimal && $v.data.volumen.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.volumen"></b-input>
                  </b-field>
                  <b-field label="Características">
                    <vue-editor
                      v-model="data.features"
                      :editorToolbar="customToolbar"
                    >
                    </vue-editor>
                  </b-field>
                  <b-field label="Especificaciones" class="doubleInput">
                    <div
                      class="doubleInput__container"
                      v-for="(s, index) in data.specs"
                      :key="index"
                    >
                      <b-field label="Nombre">
                        <b-input v-model="s.name"></b-input>
                      </b-field>
                      <b-field label="Descripción">
                        <b-input v-model="s.value"></b-input>
                      </b-field>
                      <div class="dobleInput__delete">
                        <b-button
                          type="is-danger"
                          size="is-small"
                          @click="delSpecs(index)"
                        >
                          <font-awesome-icon :icon="['fas', 'trash']" />
                        </b-button>
                      </div>
                      <br />
                    </div>
                    <b-button
                      type="is-primary"
                      size="is-small"
                      @click="addSpecs"
                    >
                      Agregar <font-awesome-icon :icon="['fas', 'plus']" />
                    </b-button>
                  </b-field>
                </div>
              </b-tab-item>
              <b-tab-item>
                <template #header>
                  <span>Galería</span>
                </template>
                <div>
                  <ListGalleryByProduct />
                </div>
              </b-tab-item>
            </b-tabs>
          </section>
        </template>
      </Card>
      <Aside>
        <Button
          variant="main"
          :spinner="loading"
          @click.native="postInfo($event)"
          block
          >Guardar</Button
        >
        <Button
          variant="danger"
          class="mt-2"
          :spinner="loading"
          @click.native="modalDelete = true"
          block
          >Eliminar</Button
        >
        <Button
          tag="router-link"
          :to="{ name: 'product_list' }"
          variant="gray"
          block
          class="mt-2"
          >Cancelar</Button
        >
      </Aside>
      <ModalDeleteProduct v-if="modalDelete" @hidden="modalDelete = false" />
    </div>
  </Layout>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { required, decimal } from 'vuelidate/lib/validators'
import Layout from '@/components/Layout'
import Card from '@/components/base/Card'
import Aside from '@/components/Aside'
import Button from '@/components/form/Button'
import Errors from '@/mixins/error'
import Upload from '@/components/base/Upload'
import ProductFormCreate from '@/components/product/ProductFormCreate'
import ModalDeleteProduct from '@/components/product/ModalDeleteProduct'
import ProductService from '@/services/ProductService'
import ListGalleryByProduct from '@/components/product/ListGalleryByProduct'
import { TYPE_PRODUCT } from '@/constants'

export default {
  name: 'ProductUpdate',
  components: {
    Layout,
    Card,
    Aside,
    Button,
    Upload,
    ProductFormCreate,
    ListGalleryByProduct,
    ModalDeleteProduct,
    VueEditor
  },
  mixins: [Errors],
  data() {
    return {
      type_products: TYPE_PRODUCT,
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link', 'image', 'video'],
        ['clean'] // remove formatting button
      ],
      activeTab: 0,
      loading: false,
      items: [
        {
          text: 'Categoría Listado',
          href: '/'
        },
        {
          text: 'Categoría Crear',
          active: true
        }
      ],
      data: {
        local: [],
        name: '',
        category: [],
        price: null,
        stock: null,
        has_stock: false,
        description: '',
        image: '',
        position: 1,
        is_active: true,
        title: '',
        meta_description: '',
        route_image: '',
        tags: [],
        size: null,
        unity: null,
        volumen: null,
        weight: null,
        specs: [],
        features: '',
        is_hidden: false,
        price_representative: null
      },
      formData: new FormData(),
      categories: [],
      locals: [],
      loading_locals: null,
      options: {
        product: null,
        name: '',
        mandatory: null,
        max_quantity: null,
        type_option: '',
        position: 1,
        is_active: true
      },
      modalDelete: false,
      modalGalleryAdd: false
    }
  },
  validations: {
    data: {
      name: { required },
      description: { required },
      price: { required, decimal },
      stock: { required },
      weight: { decimal },
      volumen: { decimal },
      type_product: { required }
    }
  },
  created() {
    this.getCategories()
    this.getLocals()
    this.getInfo()
  },
  methods: {
    async getInfo() {
      try {
        const response = await ProductService.getDetail(this.$route.params.id)
        this.data = response.data
      } catch (error) {
        this.$router.push({ name: 'product_list' })
      }
    },
    addSpecs() {
      if (this.data.specs.length > 0) {
        const item = this.data.specs.length - 1
        if (
          this.data.specs[item].name !== '' &&
          this.data.specs[item].value !== ''
        ) {
          this.data.specs.push({ name: '', value: '' })
        }
      } else {
        this.data.specs.push({ name: '', value: '' })
      }
    },
    delSpecs(index) {
      this.data.specs.splice(index, 1)
    },
    async postInfo() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.data.weight = this.data.volumen
        try {
          if (this.data.weight === '') {
            this.data.weight = null
          }
          if (this.data.volumen === '') {
            this.data.volumen = null
          }
          await ProductService.putDetail(this.$route.params.id, this.data)
          this.$store.commit('settings/SET_ALERT', {
            isAlert: true,
            type: 'S',
            msg: 'Se guardó correctamente.'
          })
          this.$router.push({ name: 'product_list' })
        } catch (error) {
          this.loading = false
          this.$store.commit('settings/SET_ALERT', {
            isAlert: true,
            type: 'D',
            msg: 'Ocurrió un error.'
          })
        }
      }
    },
    async deleteInfo() {
      this.loading = true
      try {
        await ProductService.deleteDetail(this.$route.params.id)
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se eliminó correctamente.'
        })
        this.loading = false
        this.$router.push({ name: 'product_list' })
      } catch (error) {
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    },

    uploadFileImage(file) {
      if (file) {
        const formData = new FormData()
        formData.append('image', file)
        this.postUpdateImage(formData)
      }
    },
    uploadFilePdf(file) {
      if (file) {
        const formData = new FormData()
        formData.append('pdf', file)
        this.postUpdatePDF(formData)
      }
    },
    async postUpdatePDF(formData) {
      this.loading = true
      try {
        const response = await ProductService.putPdf(
          this.$route.params.id,
          formData
        )
        this.data.pdf = response.data.pdf
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se subió correctamente la imagen.'
        })
        this.loading = false
      } catch (error) {
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
        this.loading = false
      }
    },
    async postUpdateImage(formData) {
      this.loading = true
      try {
        const response = await ProductService.putImage(
          this.$route.params.id,
          formData
        )
        this.data.image = response.data.image
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se subió correctamente la imagen.'
        })
        this.loading = false
      } catch (error) {
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
        this.loading = false
      }
    },
    async getCategories() {
      const response = await ProductService.getListCategory()
      this.categories = response.data
    },
    async getLocals() {
      const response = await ProductService.getListLocal()
      this.locals = response.data
    }
  }
}
</script>
<style lang="scss">
.scroll-container {
  max-height: 250px;
  width: 100%;
  padding: 1rem;
  border: 1px solid $color-bg;
  overflow-y: auto;
}
.unity {
  small {
    color: $color-text-opacity;
    font-size: 0.65rem;
  }
  .field.has-addons {
    display: block;
  }
}
</style>
